/* tslint:disable */
/* eslint-disable */
/**
 * PostgREST API
 * This is a dynamic API generated by PostgREST
 *
 * The version of the OpenAPI document: 10.1.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A board can be drawn on. Belongs to a room
 * @export
 * @interface OdysBoard
 */
export interface OdysBoard {
    /**
     * Note:
     * This is a Primary Key.<pk/>
     * @type {string}
     * @memberof OdysBoard
     */
    id: string;
    /**
     * Note:
     * This is a Foreign Key to `room.id`.<fk table='room' column='id'/>
     * @type {string}
     * @memberof OdysBoard
     */
    roomId: string;
    /**
     * 
     * @type {string}
     * @memberof OdysBoard
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OdysBoard
     */
    updatedAt: string;
}

export function OdysBoardFromJSON(json: any): OdysBoard {
    return OdysBoardFromJSONTyped(json, false);
}

export function OdysBoardFromJSONTyped(json: any, ignoreDiscriminator: boolean): OdysBoard {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'roomId': json['room_id'],
        'createdAt': json['created_at'],
        'updatedAt': json['updated_at'],
    };
}

export function OdysBoardToJSON(value?: OdysBoard | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'room_id': value.roomId,
        'created_at': value.createdAt,
        'updated_at': value.updatedAt,
    };
}


